import React, { useCallback } from 'react';
import WizardStepLayout from '../WizardStepLayout';
import { WIZARD_ACTIONS } from '../constants';

const NameStep = ({ state, dispatch, onNext, onBack }) => {
  const handleNameChange = useCallback(
    (e) => {
      dispatch({ type: WIZARD_ACTIONS.SET_PLACE_NAME, payload: e.target.value });
    },
    [dispatch],
  );

  const handleCaptionChange = useCallback(
    (e) => {
      dispatch({ type: WIZARD_ACTIONS.SET_CAPTION, payload: e.target.value });
    },
    [dispatch],
  );

  const isValid = Boolean(state.placeName && state.placeName.trim());

  // BUG-001 part 2: the Subtitle input is rendered unconditionally now.
  //
  // Migration 012 backfills a `Subtitle` field into every project's
  // project_fields, adminProjectsManager.php seeds it for every NEW project,
  // and FormHandler.php's protected-fields guard refuses to delete or rename
  // it. So a project will always have a backing field for the value the user
  // types here. The previous `hasSubtitleField` gate hid the input on legacy
  // projects whose form happened to omit Subtitle — that path is now closed
  // server-side, and showing the input even in a transient race-y state is
  // safer (worst case the field map drops it; best case the wizard stops
  // surprising users by silently dropping a caption).

  return (
    <WizardStepLayout
      stepNumber={3}
      onNext={onNext}
      onBack={onBack}
      nextDisabled={!isValid}
      showBack
    >
      <input
        className="wizard__input"
        type="text"
        placeholder="e.g. The old Woolworth's on State Street"
        value={state.placeName}
        onChange={handleNameChange}
      />

      <input
        className="wizard__input"
        type="text"
        placeholder="Subtitle (optional)"
        value={state.caption}
        onChange={handleCaptionChange}
      />

      <p className="wizard__helper-text">
        A subtitle appears under the place name.
      </p>
    </WizardStepLayout>
  );
};

export default React.memo(NameStep);
